import { IconSvg, IconSvgProps } from "./icon"

export default function Upload(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M20.25 17.254v1.435a2.153 2.153 0 0 1-2.152 2.152H5.902a2.15 2.15 0 0 1-2.152-2.152v-1.435M12 4.34v12.832M6.75 9.59 12 4.34l5.25 5.25" />
    </IconSvg>
  )
}
